import { boundMethod } from 'autobind-decorator';

class AppContainer {
  constructor(appAPI, appLogger, appRouting, appRoutingStep, appSession, NAVIGATION) {
    'inject';

    this._appAPI = appAPI;
    this._appLogger = appLogger;
    this._appRouting = appRouting;
    this._appRoutingStep = appRoutingStep;
    this._appSession = appSession;
    this._NAVIGATION = NAVIGATION;

    this._sessionSubscription = null;

    this.isMenuVisible = false;
  }
  activate() {
    this._sessionSubscription = this._appSession.onSessionChange(this._onSessionUpdate);
    this._onSessionUpdate();
    this._appLogger.info('App ready');
  }
  detached() {
    this._sessionSubscription.dispose();
  }
  configureRouter(config) {
    config.addPipelineStep('authorize', this._appRoutingStep);
    config.options.pushState = true;
    config.map(this._appRouting.extractRoutes(this._NAVIGATION));
  }
  @boundMethod
  _onSessionUpdate() {
    this.isMenuVisible = this._appSession.isAuthenticated();
    const token = this.isMenuVisible ?
      this._appSession.getSession().token :
      null;

    this._appAPI.setAuthorizationToken(token);
  }
}

export { AppContainer };
